import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import {
  FaEnvelope,
  FaPhone,
  FaMapMarkerAlt,
  FaPaperPlane,
  FaClock,
  FaLinkedin,
  FaTwitter,
  FaGithub,
  FaDribbble,
} from 'react-icons/fa';
import './ContactPage.css';
import handleEmail from '../utils/email';
const ContactPage = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    company: '',
    budget: '',
    subject: '',
    message: '',
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
  e.preventDefault();

  const templateParams = {
    name: formData.name,
    email: formData.email,
    phone: formData.phone || "N/A",
    company: formData.company || "N/A",
    budget: formData.budget || "Not specified",
    subject: formData.subject,
    message: formData.message,
  };

  try {
    await handleEmail(templateParams);

    alert("Thanks for contacting us! We'll get back to you soon.");

    // Optional: reset your form
    setFormData({
      name: "",
      email: "",
      phone: "",
      company: "",
      budget: "",
      subject: "",
      message: "",
    });

  } catch (error) {
    console.error("EmailJS error:", error);
    alert("Something went wrong. Please try again.");
  }
};


  const contactMethods = [
    {
      icon: FaEnvelope,
      title: 'Email Us',
      value: 'hello@Dexova.com',
      subtext: 'Send us an email anytime',
      link: 'mailto:hello@Dexova.com',
      color: '#667eea',
    },
    {
      icon: FaPhone,
      title: 'Call Us',
      value: '+1 (555) 123-4567',
      subtext: 'Mon-Fri from 9am to 6pm',
      link: 'tel:+15551234567',
      color: '#f093fb',
    },
    {
      icon: FaMapMarkerAlt,
      title: 'Visit Us',
      value: '123 Tech Street',
      subtext: 'Silicon Valley, CA 94025',
      link: '#',
      color: '#4facfe',
    },
    {
      icon: FaClock,
      title: 'Working Hours',
      value: 'Mon - Fri: 9am - 6pm',
      subtext: 'Sat - Sun: Closed',
      link: '#',
      color: '#43e97b',
    },
  ];

  const offices = [
    {
      city: 'San Francisco',
      address: '123 Tech Street, Silicon Valley, CA 94025',
      phone: '+1 (555) 123-4567',
      email: 'sf@Dexova.com',
    },
    {
      city: 'New York',
      address: '456 Innovation Ave, New York, NY 10001',
      phone: '+1 (555) 234-5678',
      email: 'ny@Dexova.com',
    },
    {
      city: 'London',
      address: '789 Tech Boulevard, London, UK EC1A 1BB',
      phone: '+44 20 1234 5678',
      email: 'london@Dexova.com',
    },
  ];

  return (
    <div className="contact-page">
      <section className="contact-hero">
        <div className="contact-hero-content">
          <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}>
            <h1>Get In Touch</h1>
            <p>Have a project in mind? Let's discuss how we can help transform your ideas into reality</p>
          </motion.div>
        </div>
      </section>

      <section className="contact-form-section" ref={ref}>
        <div className="form-section-container">
          <motion.div
            className="form-intro"
            initial={{ opacity: 0, x: -50 }}
            animate={inView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 0.6 }}
          >
            <h2>Send Us a Message</h2>
            <p>
              Fill out the form below and we'll get back to you within 24 hours. We're excited to hear about your
              project!
            </p>

            <div className="contact-features">
              <div className="contact-feature">
                <div className="feature-icon">✓</div>
                <div>
                  <h4>Quick Response</h4>
                  <p>We respond within 24 hours</p>
                </div>
              </div>
              <div className="contact-feature">
                <div className="feature-icon">✓</div>
                <div>
                  <h4>Free Consultation</h4>
                  <p>Initial consultation is always free</p>
                </div>
              </div>
              <div className="contact-feature">
                <div className="feature-icon">✓</div>
                <div>
                  <h4>NDA Available</h4>
                  <p>We can sign an NDA if required</p>
                </div>
              </div>
            </div>
            <motion.div
              className="direct-email-contact"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.3 }}
            >
              <FaEnvelope className="email-icon" />
              <p>
                Connect directly anytime via email at <a href="mailto:hello.dexova@gmail.com">hello.dexova@gmail.com</a>
              </p>
            </motion.div>
          </motion.div>

          <motion.form
            className="contact-form-large"
            onSubmit={handleSubmit}
            initial={{ opacity: 0, x: 50 }}
            animate={inView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            <div className="form-row-large">
              <div className="form-group-large">
                <label htmlFor="name">Full Name *</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  placeholder="John Doe"
                />
              </div>

              <div className="form-group-large">
                <label htmlFor="email">Email Address *</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  placeholder="john@example.com"
                />
              </div>
            </div>

            <div className="form-row-large">
              <div className="form-group-large">
                <label htmlFor="phone">Phone Number</label>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  placeholder="+1 (555) 123-4567"
                />
              </div>

              <div className="form-group-large">
                <label htmlFor="company">Company</label>
                <input
                  type="text"
                  id="company"
                  name="company"
                  value={formData.company}
                  onChange={handleChange}
                  placeholder="Your Company"
                />
              </div>
            </div>

            <div className="form-row-large">
              <div className="form-group-large">
                <label htmlFor="budget">Project Budget</label>
                <select id="budget" name="budget" value={formData.budget} onChange={handleChange}>
                  <option value="">Select budget range</option>
                  <option value="<$5k"> Less than $5,000</option>

                  <option value="$5k-10k"> $5,000-$10,000</option>
                  <option value="$10k-25k">$10,000 - $25,000</option>
                  <option value="$25k-50k">$25,000 - $50,000</option>
                  <option value="$50k-100k">$50,000 - $100,000</option>
                  <option value=">$100k">More than $100,000</option>
                </select>
              </div>

              <div className="form-group-large">
                <label htmlFor="subject">Subject *</label>
                <input
                  type="text"
                  id="subject"
                  name="subject"
                  value={formData.subject}
                  onChange={handleChange}
                  required
                  placeholder="How can we help?"
                />
              </div>
            </div>

            <div className="form-group-large">
              <label htmlFor="message">Tell us about your project *</label>
              <textarea
                id="message"
                name="message"
                value={formData.message}
                onChange={handleChange}
                required
                rows="6"
                placeholder="Describe your project requirements..."
              ></textarea>
            </div>

            <motion.button
              type="submit"
              className="submit-btn-large"
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
            >
              Send Message
              <FaPaperPlane className="btn-icon" />
            </motion.button>
          </motion.form>
        </div>
      </section>

      <section className="contact-social">
        <div className="social-container">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={inView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.6 }}
          >
            <h2>Follow Us</h2>
            <p>Stay connected on social media</p>
            <div className="social-links-large">
              <motion.a href="https://www.linkedin.com/company/dexova/" target="_blank" rel="noopener noreferrer" whileHover={{ scale: 1.1, y: -5 }} whileTap={{ scale: 0.9 }}>
                <FaLinkedin />
                <span>LinkedIn</span>
              </motion.a>
              <motion.a href="#" whileHover={{ scale: 1.1, y: -5 }} whileTap={{ scale: 0.9 }}>
                <FaTwitter />
                <span>Twitter</span>
              </motion.a>
              <motion.a href="#" whileHover={{ scale: 1.1, y: -5 }} whileTap={{ scale: 0.9 }}>
                <FaGithub />
                <span>GitHub</span>
              </motion.a>
              <motion.a href="#" whileHover={{ scale: 1.1, y: -5 }} whileTap={{ scale: 0.9 }}>
                <FaDribbble />
                <span>Dribbble</span>
              </motion.a>
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default ContactPage;
